<div class="center p-4">
    <p-card class="info-card">
        <i [class]="'info-icon mt-1 mb-2 ' + icon"></i>
        <h2 class="info-title">{{title}}</h2>
        <p class="mb-3">
            {{text}}
        </p>
    </p-card>
</div>